__turbopack_context__.v({
  "colImage": "HeroSection-module-scss-module__Mp4peG__colImage",
  "colText": "HeroSection-module-scss-module__Mp4peG__colText",
  "imgBox": "HeroSection-module-scss-module__Mp4peG__imgBox",
  "main": "HeroSection-module-scss-module__Mp4peG__main",
  "row": "HeroSection-module-scss-module__Mp4peG__row",
  "textWrap": "HeroSection-module-scss-module__Mp4peG__textWrap",
});
